import { openModal } from '@core/components/ModalStack';
import { AddEditHelpArticleModalProps } from './AddEditHelpArticleModal';

export async function openAddEditHelpArticleModal(props: AddEditHelpArticleModalProps) {
  const { AddEditHelpArticleModal } = await import('./AddEditHelpArticleModal');

  openModal(AddEditHelpArticleModal, props);
}
